var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.installmentsCount
    ? _c(
        "div",
        { attrs: { "data-qa": "installments-info" } },
        [
          _vm.isPayType
            ? [
                _vm.isInUpgradeMode
                  ? _c(
                      "localize",
                      {
                        key: _vm.formattedNewPlanAmount,
                        attrs: {
                          resource:
                            _vm.Resources.Checkout
                              .CheckoutInstallmentsUpgradeDetailsInfoLabel,
                        },
                      },
                      [
                        _c(
                          "span",
                          { attrs: { "format-key": "0", "data-qa": "count" } },
                          [_vm._v(_vm._s(_vm.installmentsCount))]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "_fw-b _whs-nw",
                            attrs: {
                              "format-key": "1",
                              "data-qa": "amount-to-pay",
                            },
                          },
                          [_vm._v(_vm._s(_vm.amountToDisplay))]
                        ),
                      ]
                    )
                  : _c(
                      "localize",
                      {
                        key: _vm.amountToDisplay,
                        attrs: {
                          resource:
                            _vm.Resources.Checkout
                              .CheckoutInstallmentsDetailsInfoLabel,
                        },
                      },
                      [
                        _c(
                          "span",
                          { attrs: { "format-key": "0", "data-qa": "count" } },
                          [_vm._v(_vm._s(_vm.installmentsCount))]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "_fw-b _whs-nw",
                            attrs: {
                              "format-key": "1",
                              "data-qa": "amount-to-pay",
                            },
                          },
                          [_vm._v(_vm._s(_vm.amountToDisplay))]
                        ),
                      ]
                    ),
              ]
            : _c(
                "localize",
                {
                  key: _vm.installmentsCount,
                  attrs: {
                    resource:
                      _vm.Resources.Checkout
                        .CheckoutInstallmentsPledgeDetailsInfoLabel,
                  },
                },
                [
                  _c(
                    "span",
                    { attrs: { "format-key": "0", "data-qa": "count" } },
                    [_vm._v(_vm._s(_vm.installmentsCount))]
                  ),
                ]
              ),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }